import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';

export default function BarChartWithData({ data }) {
    const [layout, setLayout] = React.useState('vertical');
    const [radius, setRadius] = React.useState(10);

    const allStatusCodes = React.useMemo(() => {
        const codes = new Set();
        data?.forEach((item) => {
            Object.keys(item).forEach((key) => {
                if (/^\d+$/.test(key)) codes.add(key);
            });
        });
        return Array.from(codes).sort();
    }, [data]);

    const dataset = Array.isArray(data)
        ? data.map((entry) => {
            const base = { api: entry.url.replace("/api/v1/tradingApis", "") || 'Unknown' };
            allStatusCodes.forEach((code) => {
                base[code] = entry[code] || 0;
            });
            return base;
        })
        : [];

    if (!dataset.length) {
        return (
            <Typography sx={{ mt: 4, textAlign: 'center' }}>
                No API call data available
            </Typography>
        );
    }

    return (
        <Stack direction="column" spacing={2} sx={{ width: '100%', maxWidth: 600 }}>
            <Stack direction="row" spacing={4}>

                <TextField
                    select
                    sx={{ minWidth: 150 }}
                    label="Layout"
                    value={layout}
                    onChange={(event) => setLayout(event.target.value)}
                >
                    <MenuItem value="horizontal">Horizontal</MenuItem>
                    <MenuItem value="vertical">Vertical</MenuItem>
                </TextField>
            </Stack>

            <BarChart
                dataset={dataset}
                series={allStatusCodes.map((code) => ({
                    dataKey: code,
                    // label: `${code} Status`,
                    layout,
                    stack: 'stack',
                }))}
                {...(layout === 'vertical' ? chartSettingsV : chartSettingsH)}
                borderRadius={radius}
            />
        </Stack>
    );
}

// Chart layout settings
const chartSettingsH = {
    height: 300,
    yAxis: [{ scaleType: 'band', dataKey: 'api' }],
    slotProps: {
        legend: {
            direction: 'horizontal',
            position: { vertical: 'bottom', horizontal: 'center' },
        },
    },
};

const chartSettingsV = {
    height: 300,
    xAxis: [{ scaleType: 'band', dataKey: 'api' }],
    slotProps: {
        legend: {
            direction: 'horizontal',
            position: { vertical: 'bottom', horizontal: 'center' },
        },
    },
};
